export const commonTranslations = {
  // Common actions
  Save: '저장',
  Update: '업데이트',
  Delete: '삭제',
  Cancel: '취소',
  Create: '만들기',
  Edit: '편집',
  Copy: '복사',
  Download: '다운로드',
  Upload: '업로드',
  Send: '보내기',
  Apply: '적용',
  Filter: '필터',
  Search: '검색',
  Add: '추가',
  Remove: '제거',
  Accept: '확인',

  // Common states
  Loading: '로딩 중',
  Error: '오류',
  Success: '성공',
  Failed: '실패',
  Completed: '완료',
  Processing: '{{documentCount}}개 처리 중',
  Uploading: '업로드 중...',
  Generating: '생성 중',
  ItMayTakeUpTo10MinutesToComplete: '최대 10분 소요',

  // Common messages
  AnErrorOccurred: '오류가 발생했습니다!',
  PleaseTryAgain: '다시 시도해 주세요',
  CopiedToClipboard: '클립보드에 복사됨',
  ErrorOccurred: '다음과 같은 오류가 발생했습니다.',
  DocumentNotFound: '문서를 찾을 수 없습니다',
  // Time periods
  Today: '오늘',
  Yesterday: '어제',
  LastWeek: '최근 7일',
  LastMonth: '최근 30일',
  All: '전체',

  // Summary and status
  NoSummaryHistory: '요약 기록이 없습니다.',
  SummaryGenerated: '요약이 성공적으로 생성되었습니다',
  SummaryGenerationFailed: '요약 생성에 실패하였습니다',
  SummaryGenerationSuccessNoSummary:
    '요약 생성이 완료되었으나, 표시할 내용이 없습니다',
  AnalyzingYourDocument: '문서 분석 중…',
  SummaryGenerationFailedDesc:
    '잠시 후 다시 시도하시거나, 입력한 내용을 확인해 주세요.',
  NoSummaryAvailable: '생성된 요약이 없습니다.',
  NoSummaryAvailableDesc:
    '해당 문서에서 요약을 생성할 수 없습니다. 문서 내용을 확인해 주세요.',
  AnalyzingYourDocumentDesc:
    '요약 생성을 위해 AI가 문서 내용을 검토하고 있습니다.',
  UploadFailedSummary: '업로드 중 문제가 발생했습니다',
  UploadFailedSummaryDesc: '다시 시도하거나 파일을 확인해 주세요.',
  UploadAgain: '다시 업로드',

  // Import
  ImportTitle: '⚠️ 파일을 가져오면 기존 내용이 모두 재설정됩니다.',
  ImportConfirmation: '계속하시겠습니까?',

  // Terms and Conditions
  TMCTitle: 'Cheiron 이용약관 관련 안내',
  'TMCTitleDesc.before': 'Cheiron을 계속 이용하시려면, 업데이트된',
  'TMCTitleDesc.terms': '이용약관',
  'TMCTitleDesc.and': '및',
  'TMCTitleDesc.privacy': '개인정보처리방침',
  'TMCTitleDesc.after': '을 확인하고 동의해 주세요.',
  TMCAccept: '변경사항에 동의합니다.',
  Confirm: '확인',

  // Update Document
  DocumentUpdatedSuccessfully: '문서가 성공적으로 업데이트되었습니다',
  DocumentUpdateFailed: '문서 업데이트에 실패하였습니다',
  LabilingRetryFailed: '라벨링 재시도에 실패하였습니다',
}
